import { render, staticRenderFns } from "./HistoryFirstYear.vue?vue&type=template&id=5ce71348&"
import script from "./HistoryFirstYear.vue?vue&type=script&lang=ts&"
export * from "./HistoryFirstYear.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryFirstYear.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHistoryTimeline: require('/Users/markussh/git/theodora-tech-website/src/components/section/History/HistoryTimeline.vue').default,ResponsiveImage: require('/Users/markussh/git/theodora-tech-website/src/components/ResponsiveImage.vue').default})
